import {takeLatest, put} from 'redux-saga/effects';
import {
  CREATE_SELLER,
  CREATE_SELLER_FAILED,
  CREATE_SELLER_SUCCESS,
  GET_SELLERS,
  GET_SELLERS_FAILED,
  GET_SELLERS_SUCCESS,
  UPDATE_SELLER_STATUS,
  UPDATE_SELLER_STATUS_FAILED,
  UPDATE_SELLER_STATUS_SUCCESS,
} from './constants';

import {
  CreateSellerRequestBuilder,
  GetSellersBuilder,
  GetSellersCountBuilder,
  UpdateSellerStatusRequestBuilder,
} from 'client-sdk/src/sellers/sellers';

import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import {flattenObject} from '../../utils/helpers';
import handleNotfication from '../../utils/handleNotfication';

const token = localStorage.getItem('token') || '';

export function* getSellers(actions: any): unknown {
  try {
    const makeRequest = new GetSellersBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetSellersCountBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeActiveCardCountRequest = new GetSellersCountBuilder()
      .params(
        flattenObject({
          ...actions.payload,
          sort: 'id,desc',
          'status.in': ['ACTIVE'],
        })
      )
      .build();
    const makeInactiveCardCountRequest = new GetSellersCountBuilder()
      .params(
        flattenObject({
          ...actions.payload,
          sort: 'id,desc',
          'status.in': ['INACTIVE'],
        })
      )
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    const count = yield client.execute(makeCountRequest);
    const activeCardCount = yield client.execute(makeActiveCardCountRequest);
    const inactiveCardCount = yield client.execute(
      makeInactiveCardCountRequest
    );
    yield put({
      type: GET_SELLERS_SUCCESS,
      data: response.data,
      count: count.data,
      activeCardCount: activeCardCount.data,
      inactiveCardCount: inactiveCardCount.data,
    });
  } catch (error) {
    yield put({
      type: GET_SELLERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateSellerStatus(actions: any): unknown {
  try {
    const {id, body, pagination} = actions.payload;
    const makeUpdateSellerStatusRequest = new UpdateSellerStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateSellerStatusRequest);
    yield put({
      type: UPDATE_SELLER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_SELLERS,
      payload: {...pagination, sort: 'id,desc'},
    });
    handleNotfication('وضعیت فروشنده با موفقیت تغییر پیدا کرد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_SELLER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* createSeller(actions: any): unknown {
  try {
    const {body, pagination, callback} = actions.payload;
    const makeAddSellerRequest = new CreateSellerRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeAddSellerRequest);
    yield put({
      type: CREATE_SELLER_SUCCESS,
    });
    yield put({
      type: GET_SELLERS,
      payload: {...pagination, sort: 'id,desc'},
    });
    callback();
    handleNotfication('فروشنده با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_SELLER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* sellerSaga() {
  yield takeLatest(GET_SELLERS, getSellers);
  yield takeLatest(UPDATE_SELLER_STATUS, updateSellerStatus);
  yield takeLatest(CREATE_SELLER, createSeller);
}
